import Http from '../http'

/**
 * 大文件分片上传 -初始化带有断点续传的分片上传文件
 * @param {*} data
 * @returns
 */
export function initiateMultipartUpload(data) {
  return Http.post('/bigFile/initiateBreakpointMultipartUpload', data, {
    baseURL: window.domainConfig.fileServer,
    all: true
  })
}

/**
 * 大文件分片上传 - 上传分片
 * @param {*} data
 * @returns
 */
export function uploadPart(data, uploadProcess = () => {}, errorCount = 0) {
  return Http.post('/bigFile/uploadPart', data, {
    baseURL: window.domainConfig.fileServer,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: v => {
      uploadProcess(v.loaded)
    },
    all: true
  })
    .then(res => Promise.resolve(res))
    .catch(async error => {
      if (errorCount >= 5) {
        return Promise.reject(error)
      }
      await new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, (errorCount + 1) * 1000)
      })
      return uploadPart(data, uploadProcess, errorCount + 1)
    })
}

export function completeMultipartUpload(data) {
  return Http.post('/bigFile/completeMultipartUpload', data, { baseURL: window.domainConfig.fileServer, all: true })
}
